import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Badge,
  Box,
  Chip,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import {
  useLoaderData,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { Virtuoso } from "react-virtuoso";
import { ExpandMore } from "@mui/icons-material";
import { green } from "@mui/material/colors";

const Rooms = () => {
  const { rooms, userID } = useLoaderData();

  const [searchParams] = useSearchParams();
  const { authID } = Object.fromEntries(searchParams.entries());

  const [expandedRoom, setExpandedRoom] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(true);

  const handleChangeRoom = (roomID) => (event, isExpanded) => {
    setExpandedRoom(isExpanded ? roomID : false);
    setIframeLoading(true);
  };

  const itemContent = useCallback(
    (index, room) => (
      <Accordion
        key={room["_id"]}
        expanded={expandedRoom === room["_id"]}
        onChange={handleChangeRoom(room["_id"])}
        square
        elevation={0}
        sx={{ border: 1, borderColor: "divider" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{ backgroundColor: "rgba(0, 0, 0, .03)" }}
        >
          <Stack
            width={"100%"}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography>{room["roomName"]}</Typography>
            {expandedRoom !== room["_id"] && (
              <Chip
                color="primary"
                label={room["unread_count"]}
                sx={{ mr: 2 }}
                size="small"
              />
            )}
          </Stack>
        </AccordionSummary>

        <AccordionDetails>
          {iframeLoading && <LinearProgress />}
          {expandedRoom === room["_id"] && (
            <iframe
              src={`/chat?authID=${authID}&userID=${userID}&roomID=${room["_id"]}`}
              height={530}
              style={{ width: "100%", border: 0 }}
              onLoad={() => setIframeLoading(false)}
            />
          )}
        </AccordionDetails>
      </Accordion>
    ),
    [expandedRoom, iframeLoading]
  );

  return (
    <Box sx={{ height: "100%", pt: 1, pb: 1 }}>
      {rooms.length === 0 ? (
        <Typography
          textAlign={"center"}
          sx={{ color: "lightgray" }}
          variant="body2"
        >
          No Rooms are found
        </Typography>
      ) : (
        <Virtuoso
          data={rooms}
          initialTopMostItemIndex={rooms.length}
          itemContent={itemContent}
          style={{ scrollbarGutter: "stable both-edges" }}
        />
      )}

      {/* {rooms.map((room) => (
        <Accordion key={room["_id"]}>
          <AccordionSummary>{room["roomName"]}</AccordionSummary>
          <AccordionDetails>
            <iframe
              src={`/chat?authID=${authID}&userID=${userID}&roomID=${room["_id"]}`}
              height={550}
              style={{ width: "100%", border: 0 }}
            />
          </AccordionDetails>
        </Accordion>
      ))} */}
    </Box>
  );
};

export default Rooms;
